// extracted by mini-css-extract-plugin
export var box = "_8d-1";
export var checked = "_8d-2";
export var descriptionSpacer = "_8d-9";
export var disabled = "_8d-3";
export var icon = "_8d-6";
export var input = "_8d-0";
export var labelSpacer = "_8d-8";
export var medium = "_8d-5";
export var small = "_8d-4";
export var text = "_8d-7";